import {useState} from "react";
import {EnvelopeIcon} from "@heroicons/react/20/solid";
import {OtsForm, OtsFormActions, OtsFormSection} from "../components/OtsForm";
import {OtsTextArea, OtsTextInput} from "../components/OtsTextInput";

export type AppAccessEmailDeliveryFormProps = {
  isSending?: boolean;
  disabled?: boolean;
  onSend: (recipients: string[], message?: string) => boolean | Promise<boolean>;
};

/** Directed email delivery form. A successful send clears its draft. */
export const AppAccessEmailDeliveryForm = ({
  isSending = false,
  disabled = false,
  onSend,
}: AppAccessEmailDeliveryFormProps) => {
  const [recipients, setRecipients] = useState("");
  const [message, setMessage] = useState("");

  const submit = async () => {
    const parsedRecipients = recipients.split(/[;,\s]+/).map((value) => value.trim()).filter(Boolean);
    if (parsedRecipients.length === 0) return;
    if (await onSend(parsedRecipients, message || undefined)) {
      setRecipients("");
      setMessage("");
    }
  };

  return (
    <OtsForm
      aria-label="Email setup"
      density="compact"
      onSubmit={() => void submit()}
      actions={<OtsFormActions submitLabel="Send setup email" submitIcon={<EnvelopeIcon/>} submitting={isSending} submitDisabled={disabled}/>}>
      <OtsFormSection title="Email setup" description="Send to one person or paste a list for an onboarding group. The branded setup PDF is included.">
        <OtsTextInput
          label="Recipient email addresses"
          description="Separate multiple addresses with spaces, commas, or semicolons."
          type="text"
          inputMode="email"
          placeholder="recipient@example.com; another@example.com"
          value={recipients}
          onChange={(event) => setRecipients(event.currentTarget.value)}
          disabled={disabled}
          required
          size="compact"/>
        <OtsTextArea
          label="Optional message"
          rows={2}
          value={message}
          onChange={(event) => setMessage(event.currentTarget.value)}
          disabled={disabled}
          size="compact"/>
      </OtsFormSection>
    </OtsForm>
  );
};
